// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YgaHo4WnIZsbD7g_V3ee {
  background: var(--grey-color-10);
  padding: 32px;
}

.fLXYMdHUNVd65XVwvifg {
  background-color: var(--background-color);
  padding: 16px 32px;
  border-radius: 10px;
}

.ecERAMME_tHfw83KfLYU {
  flex: 3;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
}

.liq03gFFdfCzPAtMCwIy {
  margin-top: 32px;
}

.KO01k2ipqQq6nMkOaFcG {
  background-color: var(--background-color);
  margin-top: 32px;
  padding: 32px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CohortInsightsSkill/CohortInsightsSkill.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;AACF;;AAEA;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.levelledLegendContainer {\n  background-color: var(--background-color);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.heatmapContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.heatmap {\n  margin-top: 32px;\n}\n\n.scoringFactorContainer {\n  background-color: var(--background-color);\n  margin-top: 32px;\n  padding: 32px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YgaHo4WnIZsbD7g_V3ee`,
	"levelledLegendContainer": `fLXYMdHUNVd65XVwvifg`,
	"heatmapContainer": `ecERAMME_tHfw83KfLYU`,
	"heatmap": `liq03gFFdfCzPAtMCwIy`,
	"scoringFactorContainer": `KO01k2ipqQq6nMkOaFcG`
};
export default ___CSS_LOADER_EXPORT___;
